import React, {useContext, useEffect, useState} from "react";
import TrackVASContext from "../../TrackVASContext";
import {PageTitle} from "../../../_metronic/layout/core";
import {GenericTable} from "../generic/table/GenericTable";
import {defaultList} from "../generic/InitialStates";
import {ActionsColumnFormatter} from "../../column-formatters/ActionsColumnFormatter";
import {ENTITY_ID_DEALER} from "../generic/Constants";
import {HeaderColumnFormatter} from "../../column-formatters/HeaderColumnFormatter";
import {BrandImageFormatter} from "../../column-formatters/BrandImageFormatter";
import {showConfirmDialog} from "../../generic-components/ConfirmDialog";
import {genericDelete} from "../generic/crud";
import {showToast, TOAST_SUCCESS} from "../../utils/toast/Toast";
import {DealerAddEditDialog} from "./DealerAddEditDialog";
import {DealerDetailsDialog} from "./DealerDetailsDialog";
import {OEM_LIST} from "../generic/OEMList";

export function DealersPage() {
    const myData = useContext(TrackVASContext);
    const [reload, setReload] = useState(1);
    const [pageLoadComplete, setPageLoadComplete] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showModelId, setShowModelId] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedDealerId, setSelectedDealerId] = useState(null);

    const profileBreadCrumbs = [
        {
            title: "Home",
            path: "/dashboard",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
    ];

    // Custom formatter for clickable dealer name
    const DealerNameFormatter = (cellContent, row) => {
        return (
            <a
                href="#"
                className="text-primary text-hover-primary fw-bold fs-6"
                style={{
                    textDecoration: 'none',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    display: 'inline-block'
                }}
                onClick={(e) => {
                    e.preventDefault();
                    openDetailsDialog(row.id);
                }}
            >
                {row.name}
            </a>
        );
    };

    const columns = [
        {
            dataField: "id",
            text: "Id",
            hidden: true
        }, {
            dataField: "name",
            text: "Dealer Name",
            formatter: DealerNameFormatter,
            search: true
        },
        {
            dataField: "brand",
            text: "Brand",
            formatter: BrandImageFormatter,
        },
        {
            dataField: "address",
            text: "Address",
            showInMobile: false,
        },
        {
            dataField: "operatingCity",
            text: "Operating City",
            search: true,
            showInMobile: false,
        },
        {
            dataField: "gstNumber",
            text: "GST Number",
            showInMobile: false,
        },
        {
            dataField: "action",
            text: "Actions",
            formatter: ActionsColumnFormatter,
            formatExtraData: {
                buttons:
                    [
                        {
                            name: "Edit",
                            color: "primary",
                            icon: "edit",
                            method: openEditDialog
                        },
                        {
                            name: "Delete",
                            color: "danger",
                            icon: "trash-alt",
                            method: openDeleteDialog
                        }
                    ],
            },
            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "100px",
            },
        },
    ];

    function openEditDialog(row) {
        setShowModelId(row.id);
        setShowModal(true);
    }

    function openDetailsDialog(dealerId) {
        setSelectedDealerId(dealerId);
        setShowDetailsModal(true);
    }

    function reloadData() {
        setReload(reload + 1);
    }

    async function openDeleteDialog(row) {
        const result = await showConfirmDialog("Do you really want to delete the Dealer? You will be able to delete it only if it is not used anywhere.");
        if (result) {
            genericDelete(ENTITY_ID_DEALER, row.id).then(() => {
                showToast("Dealer is Deleted!", TOAST_SUCCESS);
                reloadData();
            }).catch(() => {
                }
            ).finally(() => {
                reloadData();
            });
        }
    }

    function addButtonClicked() {
        setShowModelId(null);
        setShowModal(true);
    }

    const handleClose = () => setShowModal(false);
    const handleDetailsClose = () => {
        setShowDetailsModal(false);
        setSelectedDealerId(null);
    };

    useEffect(() => {
        myData.setBaseData({
            toolBarButtons: [
                {
                    name: "ADD DEALER",
                    color: "primary",
                    icon: "fa fa-plus",
                    onClick: addButtonClicked,
                },
            ],
        });

        setPageLoadComplete(true);

        return () => {
            myData.setBaseData({
                toolBarButtons: []
            });
        };
    }, []);

    const filters = [
        {
            dataField: "brand",
            text: "Brand",
            options: OEM_LIST.filter(oem => oem.id !== 'OTHER')
        }
    ];

    return (
        <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Dealers</PageTitle>
            <div className="card card-body">
                {pageLoadComplete && (
                    <GenericTable
                        reload={reload}
                        defaultData={defaultList}
                        columns={columns}
                        entityId={ENTITY_ID_DEALER}
                        filters={filters}
                    />
                )}
            </div>
            <DealerAddEditDialog show={showModal} handleClose={handleClose} id={showModelId} onSave={reloadData}/>
            <DealerDetailsDialog
                show={showDetailsModal}
                handleClose={handleDetailsClose}
                dealerId={selectedDealerId}
            />
        </>
    );
}
